export default __webpack_public_path__ + "static/media/advocacy_bg.2139bbdd.jpg";